import {
  RECRUIT_SAVED_CHURCH_COLUMN,
  extractEmail,
  renderPreview,
  type RecruitSavedListItem,
} from './recruitSavedAdminShared';

type Props = {
  items: RecruitSavedListItem[];
  totalCount: number;
  currentPage: number;
  itemsPerPage: number;
  isSearchMode: boolean;
  onEdit?: (item: RecruitSavedListItem) => void;
  onView?: (item: RecruitSavedListItem) => void;
  onMove?: (item: RecruitSavedListItem) => void;
  onDelete: (item: RecruitSavedListItem) => void;
};

export default function RecruitSavedListTable({
  items,
  totalCount,
  currentPage,
  itemsPerPage,
  isSearchMode,
  onEdit,
  onView,
  onMove,
  onDelete,
}: Props) {
  return (
    <div className="admin-board-manage__table-wrap">
      <table className="admin-table">
        <thead>
          <tr>
            <th>번호</th>
            <th>{RECRUIT_SAVED_CHURCH_COLUMN}</th>
            <th>교단</th>
            <th>제목</th>
            <th>등록일</th>
            <th>출처</th>
            <th>이메일</th>
            <th className="admin-board-manage__col-actions">관리</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => {
              const email = extractEmail(item.inquiry);

              return (
                <tr key={item.id}>
                  <td>
                    {isSearchMode
                      ? index + 1
                      : totalCount - ((currentPage - 1) * itemsPerPage + index)}
                  </td>
                  <td title={item.church}>{renderPreview(item.church || '-', 20)}</td>
                  <td title={item.religiousbody}>{renderPreview(item.religiousbody || '-', 12)}</td>
                  <td style={{ textAlign: 'left', maxWidth: 280 }} title={item.title}>
                    {renderPreview(item.title)}
                  </td>
                  <td>{item.date || '-'}</td>
                  <td title={item.source}>{renderPreview(item.source || '-', 16)}</td>
                  <td className="admin-board-manage__account" title={email}>
                    {renderPreview(email || '-', 24)}
                  </td>
                  <td className="admin-board-manage__col-actions">
                    <div className="admin-board-manage__actions">
                      {onView ? (
                        <button type="button" className="admin-btn view-btn" onClick={() => onView(item)}>
                          보기
                        </button>
                      ) : null}
                      {onEdit ? (
                        <button
                          type="button"
                          className="admin-btn edit-btn"
                          onClick={() => onEdit(item)}
                        >
                          수정
                        </button>
                      ) : null}
                      <button type="button" className="admin-btn delete-btn" onClick={() => onDelete(item)}>
                        삭제
                      </button>
                      {onMove ? (
                        <button
                          type="button"
                          className="admin-btn admin-board-manage__move-btn"
                          title="다른 게시판으로 이동"
                          onClick={() => onMove(item)}
                        >
                          이동
                        </button>
                      ) : null}
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={8} style={{ padding: '24px', textAlign: 'center', color: '#666' }}>
                등록된 글이 없습니다.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
